module.exports = __webpack_public_path__ + "img/evc.3058d622.png";